module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="prefs-commute-existing-address">\n    <span class="fs-hide"></span>\n    <a href="javascript://" class="js-update-address">Update</a>\n</div>\n';

}
return __p
}